// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a47ce104","342":"ea43d194","455":"108189c0","462":"d1547d99","629":"3c99ad5f","977":"4b3215a8"}[chunkId] + ".chunk.js";
};